export const pagesLinks = {
    dashboardRootTitle: 'dashboard',

    multicheck: '/multi-check',

    dashboard: '/dashboard'

  };